import { render, staticRenderFns } from "./FestivalSummary.vue?vue&type=template&id=591990c4"
import script from "./FestivalSummary.vue?vue&type=script&lang=js"
export * from "./FestivalSummary.vue?vue&type=script&lang=js"
import style0 from "./FestivalSummary.vue?vue&type=style&index=0&id=591990c4&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('591990c4')) {
      api.createRecord('591990c4', component.options)
    } else {
      api.reload('591990c4', component.options)
    }
    module.hot.accept("./FestivalSummary.vue?vue&type=template&id=591990c4", function () {
      api.rerender('591990c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/FestivalSummary.vue"
export default component.exports